/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  ReproductiveHealthDayUpsertDto,
  ReproductiveHealthMonthResponseDto,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    ReproductiveHealthDayUpsertDtoFromJSON,
    ReproductiveHealthDayUpsertDtoToJSON,
    ReproductiveHealthMonthResponseDtoFromJSON,
    ReproductiveHealthMonthResponseDtoToJSON,
} from '../models/index';

export interface GetReproductiveHealthMonthRequest {
    month?: string;
    selectedDate?: string;
    timezoneOffset?: string;
    healthProviderCode?: GetReproductiveHealthMonthHealthProviderCodeEnum;
}

export interface UpsertReproductiveHealthDayRequest {
    reproductiveHealthDayUpsertDto: ReproductiveHealthDayUpsertDto;
}

/**
 * 
 */
export class ActivityReproductiveHealthApi extends runtime.BaseAPI {

    /**
     * Return all days for a reproductive health calendar month, including spotting and menstrual flow flags. Defaults to the current local day/month when date query params are omitted.
     * Get Reproductive Health Month
     */
    async getReproductiveHealthMonthRaw(requestParameters: GetReproductiveHealthMonthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReproductiveHealthMonthResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['month'] != null) {
            queryParameters['month'] = requestParameters['month'];
        }

        if (requestParameters['selectedDate'] != null) {
            queryParameters['selectedDate'] = requestParameters['selectedDate'];
        }

        if (requestParameters['timezoneOffset'] != null) {
            queryParameters['timezoneOffset'] = requestParameters['timezoneOffset'];
        }

        if (requestParameters['healthProviderCode'] != null) {
            queryParameters['healthProviderCode'] = requestParameters['healthProviderCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/activity/reproductive-health/month`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReproductiveHealthMonthResponseDtoFromJSON(jsonValue));
    }

    /**
     * Return all days for a reproductive health calendar month, including spotting and menstrual flow flags. Defaults to the current local day/month when date query params are omitted.
     * Get Reproductive Health Month
     */
    async getReproductiveHealthMonth(requestParameters: GetReproductiveHealthMonthRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReproductiveHealthMonthResponseDto> {
        const response = await this.getReproductiveHealthMonthRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create or update the spotting and menstrual flow flags for one patient calendar date.
     * Update Reproductive Health Day
     */
    async upsertReproductiveHealthDayRaw(requestParameters: UpsertReproductiveHealthDayRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['reproductiveHealthDayUpsertDto'] == null) {
            throw new runtime.RequiredError(
                'reproductiveHealthDayUpsertDto',
                'Required parameter "reproductiveHealthDayUpsertDto" was null or undefined when calling upsertReproductiveHealthDay().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/activity/reproductive-health/day`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ReproductiveHealthDayUpsertDtoToJSON(requestParameters['reproductiveHealthDayUpsertDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Create or update the spotting and menstrual flow flags for one patient calendar date.
     * Update Reproductive Health Day
     */
    async upsertReproductiveHealthDay(requestParameters: UpsertReproductiveHealthDayRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.upsertReproductiveHealthDayRaw(requestParameters, initOverrides);
    }

}

/**
 * @export
 */
export const GetReproductiveHealthMonthHealthProviderCodeEnum = {
    AppleHealthkit: 'apple-healthkit',
    GoogleHealthConnect: 'google-health-connect'
} as const;
export type GetReproductiveHealthMonthHealthProviderCodeEnum = typeof GetReproductiveHealthMonthHealthProviderCodeEnum[keyof typeof GetReproductiveHealthMonthHealthProviderCodeEnum];
